export const variables = {
  API_URL: "https://api-licivilla.masmtb.com/api/",
  // API_URL: "https://api-mtbdev.master-planner.net/api/",
  // API_URL: "https://localhost:7214/api/",
  PHOTO_URL: "Images",
};
